import { act } from "react-dom/test-utils";
import { FirmaAvisoEntradaAction, FirmaAvisoEntradaState } from "./FirmaAvisoEntradaFinanciero";

export function reducer(state: FirmaAvisoEntradaState, action: FirmaAvisoEntradaAction): FirmaAvisoEntradaState {

    switch (action.type) {
        case "OBTENER_INFORMACION":
            return {
                ...state,
                loadingInfo: true,
                listadoPersonal: []
            }

        case "INFORMACION_CARGADA":
            return {
                ...state,
                listadoPersonal: action.payload ?? [],
                loadingInfo: false
            }

        case "NOTIFICANDO":
            return {
                ...state,
                sendingEmail: true
            }

        case "NOTIFICADO":
            return {
                ...state,
                sendingEmail: false
            }
        default:
            return state;
    }
}